<template>
    <div class="d-flex justify-space-between fl-sg-container fl-sg-highlight-bg fl-sg-highlight--text align-center px-2 my-2">
        <v-btn class="back-button" small color="primary" @click="this.onPressBackButton">{{ $t('shoppingGuide.back') }}</v-btn>
        <div v-if="$vuetify.breakpoint.smAndUp" class="d-flex align-center">
            <span v-if="this.amountOfResults !== null" class="resultText mx-1">{{
                $t('shoppingGuide.foundXArticle', { RESULT_COUNT: amountOfResults })
            }}</span>
            <v-btn
                v-if="this.showShowAllButton && $vuetify.breakpoint.smAndUp"
                class="mx-1"
                small
                color="primary"
                @click="this.onPressShowAllButton"
                >{{ $t('shoppingGuide.showAll') }}</v-btn
            >
        </div>
        <div v-else>
            <span v-if="this.amountOfResults !== null" class="resultText link" @click="this.onPressShowAllButton">{{
                $t('shoppingGuide.foundXArticle', { RESULT_COUNT: amountOfResults })
            }}</span>
        </div>
        <v-btn class="forward-button" small color="primary" @click="this.onPressForwardButton">{{ $t('shoppingGuide.next') }}</v-btn>
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';

export default Vue.extend({
    name: 'ShoppingGuideFooter',
    props: {
        showShowAllButton: {
            type: Boolean,
            default: false,
            required: false,
        },
        amountOfResults: {
            type: Number,
            default: null,
            required: false,
        },
    },
    methods: {
        onPressShowAllButton() {
            this.$emit('onPressShowAllButton');
        },
        onPressForwardButton() {
            this.$emit('onPressForwardButton');
        },
        onPressBackButton() {
            this.$emit('onPressBackButton');
        },
    },
});
</script>

<style scoped lang="scss">
.link {
    text-decoration: underline;
    cursor: pointer;
}
.resultText {
    font-size: 12px;
    font-weight: 300;
}
.fl-sg-container {
    height: 53px;
    &:after {
        content: unset;
    }
}
</style>
